import { render } from "./imgfinal.vue?vue&type=template&id=21d96b76&scoped=true"
import script from "./imgfinal.vue?vue&type=script&lang=js"
export * from "./imgfinal.vue?vue&type=script&lang=js"

import "./imgfinal.vue?vue&type=style&index=0&id=21d96b76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d96b76"]])

export default __exports__